// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import IconList from "@vanmeter/XDL/Icons/IconList";
import { createLinkIconStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    ...createLinkIconStyles({
        sizeVariant: "xsmall",
        icon: IconList,
        iconSize: 12,
        linkStyles: {
            icon: {
                iconProps: {
                    css: css`
                        &,
                        svg {
                            height: 13px;
                        }
                    `,
                },
            },
        },
    }),
};
